import { render, staticRenderFns } from "./footnav.vue?vue&type=template&id=2153ae5c&scoped=true&"
var script = {}
import style0 from "./footnav.vue?vue&type=style&index=0&id=2153ae5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153ae5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTabs})
